module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic_1.f005e352.eot";